import React from 'react'
import DataTable from 'react-data-table-component'
import './AdminDataTable.css'

export const adminDataTableStyles = {
  table: {style: {border: '1px solid #323248', borderRadius: '8px 8px 0 0', backgroundColor: '#1e1e2d'}},
  headRow: {style: {minHeight: '58px', borderBottomColor: '#323248', backgroundColor: '#1e1e2d'}},
  headCells: {style: {color: '#00ff00', fontSize: '.82rem', fontWeight: 700, letterSpacing: '.04em', textTransform: 'uppercase'}},
  rows: {
    style: {minHeight: '70px', borderBottomColor: '#323248', backgroundColor: '#1e1e2d', color: '#cdcdde'},
    stripedStyle: {backgroundColor: '#20202f'},
    highlightOnHoverStyle: {backgroundColor: '#272738', borderBottomColor: '#323248', color: '#fff', outline: 'none'},
  },
  cells: {style: {paddingTop: '.75rem', paddingBottom: '.75rem', fontSize: '.88rem'}},
  noData: {style: {minHeight: '160px', backgroundColor: '#1e1e2d', color: '#7e8299'}},
  pagination: {
    style: {minHeight: '64px', border: '1px solid #323248', borderTop: 'none', borderRadius: '0 0 8px 8px', backgroundColor: '#1e1e2d', color: '#a1a5b7'},
    pageButtonsStyle: {fill: '#a1a5b7', '&:disabled': {fill: '#56566b'}, '&:hover:not(:disabled)': {backgroundColor: '#323248'}, '&:focus': {backgroundColor: '#323248'}},
  },
}

export const adminPaginationOptions = {
  rowsPerPageText: 'Filas por página:',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos',
}

export function AdminDataTable({className = '', paginationComponentOptions, customStyles, ...props}) {
  return <div className={`admin-datatable ${className}`.trim()}>
    <DataTable
      customStyles={customStyles || adminDataTableStyles}
      paginationComponentOptions={paginationComponentOptions || adminPaginationOptions}
      persistTableHead
      responsive
      striped
      highlightOnHover
      {...props}
    />
  </div>
}

export function AdminTableSearch({value, onChange, placeholder = 'Buscar...', ariaLabel = 'Buscar'}) {
  return <div className='admin-table-toolbar'>
    <div className='admin-table-search'>
      <i className='fas fa-search' aria-hidden='true'></i>
      <input type='search' className='form-control' aria-label={ariaLabel} placeholder={placeholder} value={value} onChange={onChange} />
    </div>
  </div>
}

export function AdminTableActions({children}) {
  return <div className='admin-table-actions'>{children}</div>
}

export function AdminTableAction({variant, title, onClick, icon}) {
  return <button type='button' className={`admin-table-action admin-table-action-${variant}`} title={title} aria-label={title} onClick={onClick}>
    <i className={icon} aria-hidden='true'></i>
  </button>
}

export function AdminStatusBadge({status}) {
  const normalized = `${status || ''}`.toLocaleLowerCase('es-MX')
  const active = normalized === 'activo' || normalized === 'activa'
  return <span className={`admin-status-badge admin-status-badge-${active ? 'active' : 'inactive'}`}>{status}</span>
}
